import type {
  GetExpertsRequestPayload,
  GetExpertsPayload,
  SetCurrentPagePayload,
} from 'commons/types';
import { expertsCurrentPageTypes, getExpertsTypes } from './types';

const expertsActions = {
  setCurrentPage: (payload: SetCurrentPagePayload) => ({
    type: expertsCurrentPageTypes.SET_CURRENT_PAGE,
    payload,
  }),
  getExpertsRequest: (payload: GetExpertsRequestPayload) => ({
    type: getExpertsTypes.REQUEST,
    payload,
  }),
  getExpertsSuccess: (payload: GetExpertsPayload) => ({
    type: getExpertsTypes.SUCCESS,
    payload,
  }),
  getExpertsFailed: (payload: string) => ({
    type: getExpertsTypes.FAILED,
    payload,
  }),
};
export default expertsActions;
